<template>
  <div id="app">
    <!-- <H5Layout> -->
    <Layout>
      <div class="f-400">TEST-Open Sans 400</div>
      <div class="f-600">TEST-Open Sans 600</div>
      <div class="f-700">TEST-Open Sans 700</div>
      <!-- <router-view :style="{ minHeight: minHeight, boxSizing: 'border-box' }" /> -->
    </Layout>
    <!-- </H5Layout> -->
  </div>
</template>
<script>
  import Layout from '@/components/Layout';
  import H5Layout from '@/components/Layout/h5';
  import { getDeviceName } from '@/utils';
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        minHeight: 0,
        clientWidth: document.documentElement.clientWidth,
      };
    },

    beforeCreate() {
      localStorage.removeItem('user');
      localStorage.removeItem('isLogin');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('token');
      localStorage.removeItem('_key');

      window.forge = require('node-forge');
    },

    created() {
      localStorage.setItem('currentDeviceName', JSON.stringify(getDeviceName()));
    },
    async mounted() {
      // 监听页面刷新事件
      window.addEventListener('beforeunload', this.handleBeforeUnload);

      const res = await this.$http.common.encryptPublicKey();
      if (res.state === '11') {
        const KEY = res.data;
        sessionStorage.setItem('_key', KEY);
      }

      if (this.vcesStatus === '1') {
        this.showMessageModal('1');
      } else if (this.vcesStatus === '2') {
        this.showMessageModal('2');
      }
      this.$store.commit('setState', {
        state: 'vcesStatus',
        values: 0,
      });
      sessionStorage.setItem('vcesStatus', 0);
      /* window.addEventListener(
        'resize',
        () => (this.clientWidth = document.documentElement.clientWidth),
        false,
      );
      if (document.documentElement.clientWidth > 1024) {
        this.minHeight = `${document.documentElement.clientHeight - 100 - 225}px`;
        window.onresize = () => {
          this.minHeight = `${document.documentElement.clientHeight - 100 - 225}px`;
        };
      } else {
        this.minHeight = '300px';
      } */
      window.addEventListener(
        'hashchange',
        () => {
          const currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false,
      );
    },
    methods: {
      handleBeforeUnload() {
        if (this.$store.state.isIngenicoUpdatePending && !this.$store.state.is3dsTriggeredReload) {
          // 清除本地存储的相关信息
          localStorage.removeItem('visaToken');
          localStorage.removeItem('encryptCustomerInput');
          localStorage.removeItem('dpSessionId');
          localStorage.removeItem('sourceModal');
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('isLogin');
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('afterLoginRouter');
          sessionStorage.removeItem('searchItem');
          sessionStorage.removeItem('vcesStatus');
          sessionStorage.removeItem('visaCardType');
          sessionStorage.removeItem('userContactToken');
        }
      },
      jumpRouter() {
        this.$router.push('/account/membership');
      },
      // 消息弹窗
      showMessageModal(data) {
        // 计划已改变信息
        if (data === '1') {
          this.$messageModal.show({
            image: false,
            closeIcon: true,
            desc: 'membershipDt',
            confirmBtn: 'viewMemb',
            cancelBtn: 'cancel',
            justHide: true,
            i18nNeed: true,
            successCallback: this.jumpRouter,
            // nextStep: '/account/membership',
          });
        } else if (data === '2') {
          // Visa卡不符合此计划的资格
          this.$messageModal.show({
            i18nNeed: true,
            image: false,
            // closeIcon: true,
            desc: 'vces-check-failed',
            confirmBtn: 'ok',
            // cancelBtn: i18n.t('cancel'),
            justHide: true,
          });
        } else if (data === '3') {
          // 15分钟会话已经过期
          this.$messageModal.show({
            i18nNeed: true,
            image: false,
            title: 'sessionTime',
            closeIcon: true,
            countDescHead: 'your',
            currentCount: '15',
            unit: 'unit',
            countDescFooter: 'expired',
            confirmBtn: 'login',
            cancelBtn: 'cancel',
            nextStep: '/',
          });
        }
      },
    },

    watch: {},

    computed: {
      ...mapState(['vcesStatus']),
    },

    components: {
      Layout,
      H5Layout,
    },
  };
</script>

<style lang="scss">
  @use '@/assets/css/variables.scss' as *;
  #app {
    color: $color-blue;
  }

  .f-400 {
    @include font(16px, 400);
  }

  .f-600 {
    @include font(16px, 600);
  }

  .f-700 {
    @include font(16px, 700);
  }
</style>
